"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRowMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Checkbox = require("../../components/Checkbox/Checkbox.styles");
var _TableCell = require("../../components/TableCell/TableCell.styles");
var hoverCSS = function hoverCSS(props) {
  var interactive = props.interactive;
  if (typeof interactive === 'undefined' || interactive === false) {
    return '';
  }
  return (0, _styledToken.default)('Table.rowBackgroundColorHover', function (backgroundColor) {
    return (0, _styledComponents.css)(["&&:hover ", "{background-color:", ";}"], _TableCell.StyledTableCell, backgroundColor);
  })(props);
};
var selectedCSS = function selectedCSS(props) {
  var ariaSelected = props['aria-selected'];
  if (typeof ariaSelected === 'undefined' || ariaSelected === false) {
    return '';
  }
  return (0, _styledToken.default)('Table.rowBackgroundColorSelected', function (backgroundColor) {
    return (0, _styledComponents.css)(["&&& ", "{background-color:", ";}"], _TableCell.StyledTableCell, backgroundColor);
  })(props);
};

/** @class TableRowMixin */
/** @method */
var TableRowMixin = function TableRowMixin(props) {
  return (0, _styledComponents.css)(["vertical-align:top;& ", "{vertical-align:text-top;}", " ", ""], _Checkbox.StyledCheckbox, hoverCSS(props), selectedCSS(props));
};
exports.TableRowMixin = TableRowMixin;